import { sumLegRunAmounts } from 'src/components/dispatch/summaryLoad';
import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';

/** 1 車両ぶんの運賃。値が一切無い車両は 3 つとも null */
export type VehicleTariffTotals = {
  billingYen: number | null;
  paymentYen: number | null;
  grossProfitYen: number | null;
};

/**
 * truckId → 請求 / 支払 / 粗利 (請求 − 支払) の合計。値が一切無い車両は全て null。
 *
 * 集計元は配車サマリと同じ案件 (leg_run) の請求・支払金額（sumLegRunAmounts）。勤務単位の
 * タリフ計算結果 (shift_truck_tariff_results) を見ていたため、伝票に入力した金額が
 * 反映されず、サマリと基準も食い違っていた。
 *
 * 車両リストからは運賃に到達できない (rowGroups / DeliveryCard / VehicleRowVM の
 * いずれも金額を持たない) ため、呼び出し側の Presenter で算出して map で渡す。
 * 集計を車両リスト内部でやると deliveries を必須 prop にする必要があり、
 * /map と convenience の両呼び出しと既存テストの mount すべてに影響する。
 *
 * Why 内訳も返す: 粗利だけだと「請求が高いのか支払が安いのか」がツールチップに
 * 出せない (サンプル route-planner: components/dispatch/VehicleInfo.tsx:487-497)。
 */
export function buildGrossProfitByTruckId(
  deliveries: readonly PlanningsDeliveryWithLegRunEntity[],
): Map<number, VehicleTariffTotals> {
  const byTruckId = new Map<number, PlanningsDeliveryWithLegRunEntity[]>();
  for (const d of deliveries) {
    const list = byTruckId.get(d.truckId);
    if (list) list.push(d);
    else byTruckId.set(d.truckId, [d]);
  }

  return new Map([...byTruckId].map(([truckId, ds]): [number, VehicleTariffTotals] => {
    // 重複排除は truckId ごと（同じ案件が同一車両の複数勤務・回転に出ても 1 回だけ数える）
    const { billingYen, paymentYen, hasAmount } = sumLegRunAmounts(ds);
    return [
      truckId,
      // 値なしを 0 で返すと「請求 ¥0」と読めてしまうので内訳ごと null にする
      hasAmount
        ? { billingYen, paymentYen, grossProfitYen: billingYen - paymentYen }
        : { billingYen: null, paymentYen: null, grossProfitYen: null },
    ];
  }));
}
